import React , {useRef} from 'react'
import { gsap } from "gsap";
import { useGSAP } from "@gsap/react";
import { ScrollTrigger, SplitText } from "gsap/all";
gsap.registerPlugin(ScrollTrigger, SplitText);
const Newsletter = () => {
    const container = useRef();
  useGSAP(
    () => {

      // let split = SplitText.create(".content_para_animation", {
      //   type: "words,chars,lines",
      // });

      const tl = gsap.timeline({
        scrollTrigger: {
          trigger: container.current,
          start: "top bottom",
          end: "bottom",
          // markers: true
        },
      });
      
       tl       
       .fromTo(
          container.current,
          {  y: 80 },
          {
            y: 0,
            duration: 0.8,
            // ease: 'power3.out',
            // stagger: 0.4 // Adjust this value for the desired stagger effect
          },
        )
        .fromTo(
          ".newsletter_animation",
          { opacity: 0, y: 40 },
          {
            opacity: 1,
            y: 0,
            duration: 0.9,
            
          }, "0"
        )
      return () => {
        tl.kill();
      };
    },
    { scope: container },
  );
    return (
        <div className="container">
            <div className="footer-top-1 bg-theme " ref={container}>
                <div className="footer-top-content">
                    <h3 className="footer-top-title text-white newsletter_animation">Newsletter</h3>
                    <p className="footer-top-text newsletter_animation">
                       Reach out today and discover what Meridianitc can do for you.
                    </p>
                </div>
                <form className="newsletter-form newsletter_animation">
                    <div className="form-group">
                        <input
                            className="form-control"
                            type="email"
                            placeholder="Email Address"
                            required=""
                        />
                        <button type="submit" className="global-btn">
                            Subscribe
                            <span className="icon">
                                <i className="fa-sharp fas fa-paper-plane ms-2" />
                            </span>
                        </button>
                    </div>
                </form>
            </div>
        </div>

    )
}

export default Newsletter